import React, { Component } from 'react'
import { isTokenValid } from '../util/service'
import baseUrls from '../util/config'

export default class RedirectionIndex extends Component {
    componentDidMount = () => {
        window.open(baseUrls?.map + '/map/free-navigation', '_self')
    }

    render() {
        return null
    }
}
